import http from './httpService';

/*global API */
const adminEndpoint = `${API}/api/Admin/`;

export function getDataForAdminUser() {
  return http.get(adminEndpoint + 'getDataForAdminRole');
}

export function getTenantsForAdminUser() {
  return http.get(adminEndpoint + 'getTenantsForAdminRole');
}

export function getUsersForAdminUser() {
  return http.get(adminEndpoint + 'getUsersForAdminRole');
}

export function getJobsFilteredWithTenant(paramsTmp) {
  return http.get(adminEndpoint + 'getJobsFilteredWithTenant', {
    params: {
      Title: paramsTmp.Title,
      Field: paramsTmp.Field,
      Experience: paramsTmp.Experience?.value,
      EmploymentType: paramsTmp.EmploymentType?.value,
      JobStatus: paramsTmp.JobStatus?.value,
      JobType: paramsTmp.JobType?.value,
      PageNumber: paramsTmp.PageNumber,
      PageSize: paramsTmp.PageSize,
      TenantId: paramsTmp.SelectedTenant?.value,
    },
  });
}

export function getInfoForAdminUser() {
  return http.get(adminEndpoint + 'getInfoForAdminRole');
}

export function getTenantDetails(id) {
  return http.get(adminEndpoint + 'getTenantDetails', {
    params: { tenantId: id },
  });
}

export function confirmEmailManually(id, isEmailConfirmed) {
  return http.put(adminEndpoint + 'confirmEmailManually', {
    userId: id,
    isEmailConfirmed,
  });
}
